"use client";
import { styled } from "@mui/material/styles";
import { FontSize400, FontSize500, FontSize700, ColorTextLink, ColorGray900, FontLineHeightSm, FontSize600, FontWeightDefault } from "@nxt-costco-com/forge-design-tokens";
const MarkdownContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "linkColor" && prop !== "styles"
})(({ linkColor, styles }) => ({
  "h1, h2, h3": {
    margin: 0,
    fontWeight: FontWeightDefault,
    fontSize: FontSize600,
    lineHeight: FontLineHeightSm,
    color: ColorGray900
  },
  a: {
    color: linkColor ? linkColor : ColorTextLink
  },
  "@media (min-width: 768px)": {
    h1: {
      fontSize: FontSize700
    },
    h2: {
      fontSize: FontSize500
    },
    h3: {
      fontSize: FontSize400
    }
  },
  ...styles
}));
export {
  MarkdownContainer
};
